import React, { Fragment } from "react";
import PropTypes from "prop-types";

import { Box, Typography } from "@telus-uds/components-web";
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';
import { Button } from "../../design/css";

const DefectSummaryHeader = ({
    reportedOn,
    webForm,
    priority,
    status,
    assignee,
    setAssigneeModal,
    isAdmin
}) => {
    const locale = useLocaleContext();
    const {
        DEFECT_MANAGEMENT: { DEFECT_TABLE: { REPORTED_ON, WEBFORM, PRIORITY, STATUS, ASSIGNEE } = {} } = {}
    } = locale === 'en-US' ? EN : FR;

    const getButton = (onClick, label, isDisabled) => (
        <Button onClick={onClick} disabled={isDisabled}>
            {label}
        </Button>
    );

    return (
        <Fragment>
            <Box bottom={3}>
                <Typography variant={{ bold: true, colour: 'brand' }}>
                    {REPORTED_ON}:{' '}
                </Typography>
                <Typography>{reportedOn}</Typography>
            </Box>
            <Box bottom={3}>
                <Typography variant={{ bold: true, colour: 'brand' }}>
                    {WEBFORM}:{' '}
                </Typography>
                <Typography>{webForm}</Typography>
            </Box>
            <Box bottom={3}>
                <Typography variant={{ bold: true, colour: 'brand' }}>
                    {PRIORITY}:{' '}
                </Typography>
                <Typography>{priority} </Typography>
            </Box>
            <Box bottom={3}>
                <Typography variant={{ bold: true, colour: 'brand' }}>
                    {STATUS}:{' '}
                </Typography>
                <Typography>{status} </Typography>
            </Box>
            {isAdmin &&
                <Box>
                    <Typography variant={{ bold: true, colour: 'brand' }}>
                        {ASSIGNEE}:{' '}
                    </Typography>
                    {getButton(
                        () => setAssigneeModal(true),
                        (assignee && assignee.length > 0 && assignee[0].label) ? `[ ${assignee[0].label.toString().toLowerCase()} ]` : '[ assign defect ]'
                    )}
                </Box>
            }
        </Fragment>
    );
};

DefectSummaryHeader.prototype = {
    reportedOn: PropTypes.string.isRequired,
    webForm: PropTypes.string.isRequired,
    priority: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
};

export default DefectSummaryHeader;
